import React,{useState} from 'react';
import {FiClock,FiRotateCcw,FiX} from 'react-icons/fi';
import {restoreStoryVersion,restoreAiCheckpoint} from '../lib/storyVersions.js';
import {currentAssemblyCut} from '../lib/assemblyCuts.js';
import {formatTime} from '../lib/editModel.js';

export default function AssemblyCutHistory({paper,onChange,onClose,disabled=false}){
 const [pending,setPending]=useState(null),[error,setError]=useState('');
 const name=currentAssemblyCut(paper).name;
 const checkpoints=[...(paper.aiCheckpoints||[])].reverse().map(v=>({...v,kind:'auto'}));
 const legacy=[...(paper.storyVersions||[])].reverse().map(v=>({...v,kind:'saved'}));
 const history=[...checkpoints,...legacy].sort((a,b)=>String(b.createdAt||'').localeCompare(String(a.createdAt||'')));
 const restore=()=>{
  if(!pending)return;
  try{
   const next=pending.kind==='auto'?restoreAiCheckpoint(paper,pending.id):restoreStoryVersion(paper,pending.id);
   onChange(next);setPending(null);setError('');onClose();
  }catch(e){setError(e.message||'Could not recover this edit.');}
 };
 return <div className="assembly-history-backdrop" role="presentation" onMouseDown={e=>{if(e.target===e.currentTarget)onClose();}}>
  <section className="assembly-history-dialog" role="dialog" aria-modal="true" aria-labelledby="assembly-history-title"
   onKeyDown={e=>{if(e.key==='Escape'){e.stopPropagation();onClose();}}}>
   <header><div><small>ASSEMBLY / {name}</small><h2 id="assembly-history-title">History</h2>
    <p>Recover an earlier edit without changing your other cuts.</p></div>
    <button type="button" onClick={onClose} title="Close history" aria-label="Close history"><FiX/></button></header>
   <div className="assembly-history-list">
    {!history.length&&<p className="assembly-history-empty"><FiClock/> Recovery points appear here when you apply AI edits. Your working cuts save automatically.</p>}
    {history.map(item=><div className="assembly-history-item" key={item.kind+'-'+item.id}>
      <div><strong>{item.title}</strong><small>{item.createdAt?new Date(item.createdAt).toLocaleString():'Earlier edit'} · {item.snapshot?.blocks?.length||0} passages · {formatTime((item.snapshot?.blocks||[]).reduce((t,b)=>t+Math.max(0,b.end-b.start),0))}</small></div>
      <button type="button" disabled={disabled} onClick={()=>{setPending(item);setError('');}}><FiRotateCcw/> Recover</button>
    </div>)}
   </div>
   {pending&&<footer><span>Recover “{pending.title}”? Your current cut will have a safety backup in History.</span>
    <button type="button" onClick={()=>setPending(null)}>Cancel</button><button type="button" className="primary" onClick={restore} disabled={disabled}>Recover cut</button></footer>}
   {error&&<p className="assembly-cut-error" role="alert">{error}</p>}
  </section>
 </div>;
}
